const WaitRipple = (  props: { className?: string, text?:string } ) => (
    <div className={`ldsRipple ${ props.className ?  props.className : "" }`}>
        {props.text && <h2>{props.text}</h2> }
        
        <div></div><div></div></div> );

export default WaitRipple;